import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthGuard = () => {
  const isAuthenticated = useSelector(state => state.auth.logged);

  if (!isAuthenticated) {
    return <Navigate to="/intro" />;
  }
  return <Outlet />;
};

export default AuthGuard;
